<ng-container *ngIf="!state.user">
  <div
    id="g_id_onload"
    data-client_id="387343500342-obn0crc436d0kubai59g2frmat1sbmvl.apps.googleusercontent.com"
    data-context="signin"
    data-callback="googleOneTapPostLogin"
    data-cancel_on_tap_outside="false"
    data-prompt_parent_id="g_id_onload"
    style="position: fixed; right: 5px; z-index: 50"
    [style.top]="oneTapTopSpacing + 'px'"
    [class.hidden]="!showGlobalGoogleLogin"
    *onlyForScreens="['desktop', 'tablet']"
  ></div>
  <div *onlyForScreens="['mobile']">
    <div
      id="g_id_onload"
      data-client_id="387343500342-obn0crc436d0kubai59g2frmat1sbmvl.apps.googleusercontent.com"
      data-context="signin"
      data-callback="googleOneTapPostLogin"
      data-cancel_on_tap_outside="false"
      data-prompt_parent_id="g_id_onload"
      style="position: fixed; right: 5px; z-index: 50"
      [style.top]="oneTapTopSpacing + 'px'"
      *ngIf="showGlobalGoogleLogin"
    ></div>
  </div>
</ng-container>

<div appSwipe (onSwipe)="onSwipeDown($event)">
  <router-outlet></router-outlet>

  <app-dialogs></app-dialogs>
  <!-- e2e test doesn't like it when this is loaded later-->
  @defer (on idle) {
  <app-tooltip-global></app-tooltip-global>
  <app-toasts></app-toasts>
  <app-mobile-menus></app-mobile-menus>
  <app-context-menu-global></app-context-menu-global>
  <app-route-loader [active]="routeLoading"></app-route-loader>
  } @defer (when showCookieBanner) {
  <app-cookie-banner *ngIf="showCookieBanner" (onHide)="hideCookieBanner()"></app-cookie-banner>
  } @defer (when showServerTiming) {
  <app-server-timing *ngIf="showServerTiming"></app-server-timing>
  }
</div>
